import { memo } from 'react';
import { components, ControlProps } from 'react-select';
import { Flex } from '@chakra-ui/react';

import { CountryCodeDisplay } from '../CountryCodeDisplay';
import { CountryOption } from '../types/CountryOption';

const ControlComponent = ({
  children,
  ...props
}: ControlProps<CountryOption, false>) => {
  const value = props.getValue()[0]; // Not multi

  return (
    <components.Control {...props}>
      <Flex alignItems="center" pl={2} w="full">
        {value && <CountryCodeDisplay code={value.value} />}
        {children}
      </Flex>
    </components.Control>
  );
};

export const Control = memo(ControlComponent);
